import * as React from 'react';
// eslint-disable-next-line import-x/order
import { useSelector } from 'react-redux';

import { NewbuildingBookedFromDeveloperButton } from 'shared/components/NewbuildingBookedFromDeveloperButton';

import { DefaultContactsLayout } from '../../components/NewbuildingContactsLayout';
import { selectIsBookedFromDeveloper } from '../../selectors/newbuildingBookedFromDeveloper';
import { NewbuildingBrokerOfferBookingButtonContainer } from '../NewbuildingBrokerOfferBookingButtonContainer';

export interface INewbuildingContactsContainerProps {
  contactsButton: React.ReactNode;
  messageButton?: React.ReactNode;
  messageButtonInSeparateRow?: boolean;
}

export const NewbuildingContactsContainer = ({
  contactsButton,
  messageButton,
  messageButtonInSeparateRow,
}: INewbuildingContactsContainerProps) => {
  const isBookedFromDeveloper = useSelector(selectIsBookedFromDeveloper);

  if (isBookedFromDeveloper) {
    return (
      <NewbuildingBookedFromDeveloperButton
        buttons={
          <DefaultContactsLayout
            contactsButton={contactsButton}
            messageButton={messageButton}
            messageButtonInSeparateRow={messageButtonInSeparateRow}
          />
        }
      />
    );
  }

  return (
    <DefaultContactsLayout
      contactsButton={contactsButton}
      messageButton={messageButton}
      offerBookingButton={<NewbuildingBrokerOfferBookingButtonContainer />}
      messageButtonInSeparateRow={messageButtonInSeparateRow}
    />
  );
};
